import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@Env/environment';
import { Document } from './document.model';
import { DaoGeneric } from '@Services/base/daoService';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends DaoGeneric<Document> {
  private url = `${environment.baseUrl}/api_bdc/documents/`;

  private imageExtensions: Map<string, string> = new Map<string, string>([
    ['xls', 'fa-file-excel-o'],
    ['xlsx', 'fa-file-excel-o'],
    ['ods', 'fa-file-excel-o'],
    ['doc', 'fa-file-word-o'],
    ['docx', 'fa-file-word-o'],
    ['odt', 'fa-file-word-o'],
    ['pdf', 'fa-file-pdf-o'],
    ['pptx', 'fa-file-powerpoint-o'],
    ['ppt', 'fa-file-powerpoint-o'],
    ['odp', 'fa-file-powerpoint-o'],
    ['png', 'fa-image'],
    ['jpg', 'fa-image'],
    ['jpeg', 'fa-image'],
    ['gif', 'fa-image'],
  ]);

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  upload(document: Document): Observable<Document> {
    const formData: FormData = new FormData();

    if (typeof(document.file) !== 'string') {
      formData.append('file', document.file, document.file.name);
    }
    formData.append('title', document.title);

    return this.httpClient.post<Document>(this.url, formData);
  }

  download(doc: Document) {
    this.getFile(doc.id).subscribe(data => {
      FileSaver.saveAs(data, doc.filename);
    });
  }

  getFile(id: number) {
    const url = `${environment.baseUrl}/api_bdc/download/`;

    return this.httpClient.get<Blob>(url, {
      params: {id: id.toString()},
      responseType: 'blob' as 'json'
    });
  }

  getPictoFromExtension(doc: Document) {
    const defaultPicto = 'fa-file-o';

    if (doc && doc.filename) {
      const ext = doc.filename.split('.').pop();
      if (this.imageExtensions.has(ext)) {
        return this.imageExtensions.get(ext);
      }
    }

    return defaultPicto;
  }
}
